import { render } from "./OmotenashiSelection2024.vue?vue&type=template&id=7b5060cb&scoped=true"
import script from "./OmotenashiSelection2024.vue?vue&type=script&lang=js"
export * from "./OmotenashiSelection2024.vue?vue&type=script&lang=js"

import "./OmotenashiSelection2024.vue?vue&type=style&index=0&id=7b5060cb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5060cb"]])

export default __exports__